import React from 'react';
import ReactDOM from 'react-dom';
import firebase from 'firebase';
import { HttpLink } from 'apollo-link-http';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from 'react-apollo';
import 'whatwg-fetch';
import { setContext } from 'apollo-link-context';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Application from './services/Application';

import './css/theme.css';
import './css/index.css';

const appModel = new Application();

firebase.auth().onAuthStateChanged(async firebaseUser => {
  if (firebaseUser) {
    const idToken = await firebaseUser.getIdToken(true);
    appModel.user = await appModel.nightingaleService.authenticate(firebaseUser, idToken);
    appModel.user.token = idToken;
  } else {
    appModel.user = null;
  }


  const httpLink = new HttpLink({ uri: process.env.REACT_APP_NIGHTINGALE_ENDPOINT });
  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      authorization: appModel.user.token ? `Bearer ${appModel.user.token}` : '',
      'x-api-key': process.env.REACT_APP_NIGHTINGALE_API_KEY,
    },
  }));
  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    credentials: 'include',
  });

  ReactDOM.render(<ApolloProvider client={client}><App app={appModel} /></ApolloProvider>, document.getElementById('root'));
  registerServiceWorker();
});



// WEBPACK FOOTER //
// ./src/index.js